import { Component } from '@angular/core';
import { routeAnimation, AuthService, LocalStorageService, DataService } from './core/core.module';
import { RouterOutlet } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations:[routeAnimation]
})
export class AppComponent {
  title = 'EVOPURE';

  constructor(
    private authService:AuthService,
    private localStorageService:LocalStorageService,
    private data:DataService,
    private http:HttpClient
  ){}
  
  
  ngOnInit(): void {
    
    //pour la duree de localstorage
    let newDate = new Date().getTime();
    let date:any = this.localStorageService.getItem('date_EVOPURE')
    
    if(newDate-date>1000*60*24*7 ){
      this.localStorageService.clear();
    }
    //pour le login automatique
    if(this.localStorageService.getItem("cle_axe_rh_referentiel_EVOPURE")){
      this.authService.login = true;
    }


    //pour lire le document json
    
      // console.log(this.data.myconfig);
      
      
    
    
  }
  
  prepareRoute(outlet:RouterOutlet){
    return outlet && outlet.activatedRouteData && outlet.activatedRouteData['feature'];
  }
}
